import { cn } from "../shared/ui/index.ts";
import { appOpenMessageConversation } from "../core/app-bridge.ts";
import {
  AdvancedGrid,
  type GridColumn,
} from "../shared/advanced-grid/advanced-grid.component.tsx";
import {
  MESSAGE_CONVERSATIONS,
  type MessageConversation,
} from "../messages/conversations.ts";

export function MessagesGridWidget({ panelId }: { panelId: string }) {
  const columns: GridColumn<MessageConversation>[] = [
    {
      id: "unread",
      label: "•",
      accessor: (r) => r.unread,
      sortable: true,
      width: "32px",
      align: "center",
      render: (r) =>
        r.unread > 0 ? (
          <span className="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-sf-primary px-1 text-[10px] font-semibold text-white">
            {r.unread}
          </span>
        ) : null,
    },
    {
      id: "name",
      label: "Nom",
      accessor: (r) => r.name,
      sortable: true,
      width: "180px",
      render: (r) => (
        <span
          className={cn(
            "text-sf-text",
            r.unread > 0 ? "font-semibold" : "font-medium",
          )}
        >
          {r.name}
        </span>
      ),
    },
    {
      id: "preview",
      label: "Aperçu",
      accessor: (r) => r.preview,
      sortable: false,
      render: (r) => <span className="text-sf-text-muted">{r.preview}</span>,
    },
    {
      id: "time",
      label: "Heure",
      accessor: (r) => r.time,
      sortable: true,
      width: "90px",
      align: "right",
      render: (r) => (
        <span className="text-sf-text-muted tabular-nums">{r.time}</span>
      ),
    },
    {
      id: "online",
      label: "En ligne",
      accessor: (r) => (r.online ? 1 : 0),
      sortable: true,
      width: "90px",
      align: "center",
      defaultVisible: false,
      render: (r) =>
        r.online ? (
          <span className="inline-block size-2 rounded-full bg-emerald-500" />
        ) : (
          <span className="inline-block size-2 rounded-full bg-neutral-300" />
        ),
    },
  ];

  return (
    <AdvancedGrid<MessageConversation>
      instanceId={panelId}
      columns={columns}
      rows={MESSAGE_CONVERSATIONS}
      rowKey={(r) => String(r.id)}
      onRowClick={(r) => appOpenMessageConversation(r.id)}
      emptyMessage="Aucune conversation."
    />
  );
}
